/**
 * Time conversion between stored telemetry-note timeOffsets and the shared
 * session timeline. Notes store telemetry-timeline seconds; the video
 * timeline displays session (video) seconds. In video-only mode the sync
 * offset is always 0, so both timescales coincide.
 */

/** Session (video) timeline seconds → stored note timeOffset. */
export const noteTimeOffsetFromSessionTime = (
  sessionTime: number,
  syncOffset: number,
): number => sessionTime + syncOffset;

/** Stored note timeOffset → session (video) timeline seconds. */
export const sessionTimeFromNoteTimeOffset = (
  timeOffset: number,
  syncOffset: number,
): number => timeOffset - syncOffset;
